import React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

// A bordered list of items, each rendered by `renderItem` with a "Ta bort" button — the house
// style for a simple, immediately-persisted "list with remove" (role users, konton per projekt,
// account aliases). Rows that also expand or edit in place use a bespoke layout instead.
export default function RemovableList<Item>(
    { items, getKey, renderItem, onRemove, emptyText }: {
        items: Item[],
        getKey: (item: Item) => React.Key,
        renderItem: (item: Item) => React.ReactNode,
        onRemove: (item: Item) => void,
        emptyText?: string,
    }) {
    if (items.length === 0)
        return emptyText === undefined ? null
            : <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>{emptyText}</Typography>
    return (
        <Box sx={{ border: '1px solid #eee', borderRadius: 1, mb: 1 }}>
            {items.map(item => (
                <Box key={getKey(item)} sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1, py: 0.5,
                        borderTop: '1px solid #eee', '&:first-of-type': { borderTop: 0 } }}>
                    <Box sx={{ flex: 1, minWidth: 0 }}>{renderItem(item)}</Box>
                    <Button size="small" color="error" sx={{ minWidth: 0, px: 1 }}
                        onClick={() => onRemove(item)}>Ta bort</Button>
                </Box>
            ))}
        </Box>
    )
}
